<template>
  <v-snackbar
    v-model="snackbar"
    :timeout="timeout"
    :color="color"
    :location="location"
    :variant="variant"
    @update:model-value="handleClose"
  >
    <span class="text-body-1">{{ message }}</span>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SnackbarComponent',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    timeout: {
      type: Number,
      default: 4000
    },
    location: {
      type: String,
      default: 'top',
      validator: (value) => [
        'top', 'bottom', 'left', 'right',
        'top left', 'top right', 'top center',
        'bottom left', 'bottom right', 'bottom center',
        'left top', 'left bottom', 'left center',
        'right top', 'right bottom', 'right center',
        'center'
      ].includes(value)
    },
    variant: {
      type: String,
      default: 'elevated',
      validator: (value) => ['elevated', 'flat', 'tonal', 'outlined', 'text', 'plain'].includes(value)
    }
  },
  emits: ['update:modelValue'],
  computed: {
    snackbar: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:modelValue', false)
    }
  },
  watch: {
    modelValue(newVal) {
      if (newVal && this.timeout > 0) {
        // Auto-close after timeout
        setTimeout(() => {
          this.snackbar = false
        }, this.timeout)
      }
    }
  }
}
</script>

<style scoped>
.v-snackbar {
  z-index: 9999;
}
</style>

